<!-- =========================================================================================
  File Name: ScheduleViewSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>ASSIGN A SCHEDULE</h4>
        <!-- <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} SCHEDULE</h4> -->
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
   <div class="p-6">
        <!-- <div class="flex">
          <vs-checkbox v-model="NewBox" @change="newcheck(NewBox)">Add New</vs-checkbox>
        </div> -->
      <div v-if="ExBox" >
        <label class="vs-select--label w-full">Copy from Schedule Templates</label>
        <v-select  label="name" :clearable="false"  :closeOnSelect="true" v-model="dataSchedule" @input="MakeTemplateSchedule(dataSchedule)" :options="schedules"  />
           <div class="slot-fields" v-for="(date, index) in currrent_schedule.dates" :key="index">
        <br>   {{index}}
      <vs-button class="float-right" v-if="date.length==0" color="primary" size="small" @click.native="inputAdd(index)"> <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/> </vs-button>
      <!-- <vs-button v-if="date.length==0" class="p-1 mt-1" size="small" @click="inputAdd(index)"><feather-icon icon="PlusIcon" svgClasses="w-4 h-4" /> </vs-button>     -->
    <div class="slot-fields mt-1" v-for="(item, dayindex) in date" :key="dayindex">
    <small style="color:red">{{getTime(index,dayindex,item.start_time,item.end_time)}}</small>
    <vs-row>
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
   <flat-pickr v-model="item.start_time" :config="configdateTimePicker" class="timepicker" name="start_time" placeholder="Start time"/>
   </vs-col>
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
    <flat-pickr v-model="item.end_time" :config="configdateTimePicker" class="timepicker" name="end_time" placeholder="End time"/>
    <!-- <span class="danger" @click="inputRemove(index,dayindex)" style="color:red">x</span> -->
   </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2" >
      <vs-button color="danger" size="small" @click.native="inputRemove(index,dayindex)" > <feather-icon icon="MinusIcon" svgClasses="h-4 w-4"/> </vs-button>
    </vs-col>
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2" v-if="currrent_schedule.dates[index].length-1===dayindex">
      <vs-button color="primary" size="small" @click.native="inputAdd(index)"> <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/> </vs-button>
    </vs-col>

  </vs-row>
    </div>
      <vs-tooltip text="Copy to all days" position="left">
       <vs-button @click.native="copytoall()" class="p-1 mt-1" size="small" v-if="index==='Monday' && currrent_schedule.dates.Monday.length > 0 && currrent_schedule.dates.Monday[0].start_time.length>0 && currrent_schedule.dates.Monday[0].end_time.length>0"><feather-icon icon="ArrowDownIcon" svgClasses="w-4 h-4" /> </vs-button>    
       </vs-tooltip>
        </div>
        </div>
  </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button  class="mr-6" @click.native="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import moment from 'moment'
import moduleDataList from '@/store/data-list/moduleDataList.js'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import {CREATE_SCHEDULE, UPDATE_SCHEDULE, ALL_SCHEDULE, CREATE_USER_ACTIVITY, UPDATE_USER_ACTIVITY, CREATE_STUDENT_SCHEDULE} from '@/graphql'
import {UPDATE_STUDENT} from '@/graphql'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    Datepicker,
    flatPickr,
    moment
  },
  data () {
    return {
      dataId: null,
      ExBox:true,
      // ViewBox:true,
      dataStudentSchedule:{
        schedule:{
          scheduledates:{

          }
        }
      },
      dataSibling:'',
      dataSchedule:'',
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      current_schedule_dates:'',
      templateSchedule:'',
      oldSchedule:'',
      previewSchedule:'',
      currrent_schedule:
        {
          'id': '',
          'name': '',
          'dates': {
            Monday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ],
            Tuesday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ],
            Wednesday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ],
            Thursday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ],
            Friday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ],
            Saturday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ],
            Sunday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ]
          }
        },
      configdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        timeFormat: 'H:i',
        time_24hr: false,
        altInput: true,
        dateFormat: 'H:i'
      },
      schedules:[],
      ddd:''
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const {id, schedule, cameras} = JSON.parse(JSON.stringify(this.data))
        // const student_schedule = []
        this.dataId = id
        // for (let i = 0; i < cameras.length; i++) {
        //   if (cameras[i].schedule) {
        //     for (let j = 0; j < cameras[i].schedule.scheduledates.length; j++) {
        //       student_schedule.push(cameras[i].schedule.scheduledates[j])
        //     }
        //   } else {
        //     for (let j = 0; j < cameras[i].location.schedule.scheduledates.length; j++) {
        //       student_schedule.push(cameras[i].location.schedule.scheduledates[j])
        //     }
        //   }
        // }
        // this.dataStudentSchedule.schedule.scheduledates = student_schedule
        if (schedule) {
          this.currrent_schedule.dates = {
            Monday: [],
            Tuesday: [],
            Wednesday: [],
            Thursday: [],
            Friday: [],
            Saturday: [],
            Sunday: []
          }
          const getarry = []
          for (let i = 0; i < schedule.scheduledates.length; i++) {
            //  delete scheduledates[i].id
            delete schedule.scheduledates[i].__typename
            delete schedule.scheduledates[i].id
            getarry.push(schedule.scheduledates[i])
          }
          for (let i = 0; i < getarry.length; i++) {
            const day = getarry[i].day
            if (day == 'Monday') {
              this.currrent_schedule.dates.Monday.push(getarry[i])
            }
            if (day == 'Tuesday') {
              this.currrent_schedule.dates.Tuesday.push(getarry[i])
            }
            if (day == 'Wednesday') {
              this.currrent_schedule.dates.Wednesday.push(getarry[i])
            }
            if (day == 'Thursday') {
              this.currrent_schedule.dates.Thursday.push(getarry[i])
            }
            if (day == 'Friday') {
              this.currrent_schedule.dates.Friday.push(getarry[i])
            }
            if (day == 'Saturday') {
              this.currrent_schedule.dates.Saturday.push(getarry[i])
            }
            if (day == 'Sunday') {
              this.currrent_schedule.dates.Sunday.push(getarry[i])
            }
          }
        }
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
          this.initValues()
        }
      }
    },
    isFormValid () {
      if (this.ExBox) {
        return !this.errors.any()
      }
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    copytoall () {
      this.currrent_schedule.dates.Tuesday.length = 0
      this.currrent_schedule.dates.Wednesday.length = 0
      this.currrent_schedule.dates.Thursday.length = 0
      this.currrent_schedule.dates.Friday.length = 0
      this.currrent_schedule.dates.Saturday.length = 0
      this.currrent_schedule.dates.Sunday.length = 0
      for (let index = 0; index < this.currrent_schedule.dates.Monday.length; index++) {
        this.currrent_schedule.dates.Tuesday.push({
          'start_time': this.currrent_schedule.dates.Monday[index].start_time,
          'end_time': this.currrent_schedule.dates.Monday[index].end_time
        })
        this.currrent_schedule.dates.Wednesday.push({
          'start_time': this.currrent_schedule.dates.Monday[index].start_time,
          'end_time': this.currrent_schedule.dates.Monday[index].end_time
        })
        this.currrent_schedule.dates.Thursday.push({
          'start_time': this.currrent_schedule.dates.Monday[index].start_time,
          'end_time': this.currrent_schedule.dates.Monday[index].end_time
        })
        this.currrent_schedule.dates.Friday.push({
          'start_time': this.currrent_schedule.dates.Monday[index].start_time,
          'end_time': this.currrent_schedule.dates.Monday[index].end_time
        })
        this.currrent_schedule.dates.Saturday.push({
          'start_time': this.currrent_schedule.dates.Monday[index].start_time,
          'end_time': this.currrent_schedule.dates.Monday[index].end_time
        })
        this.currrent_schedule.dates.Sunday.push({
          'start_time': this.currrent_schedule.dates.Monday[index].start_time,
          'end_time': this.currrent_schedule.dates.Monday[index].end_time
        })   
      }
    },
    MakeTemplateSchedule (dates) {
      if(dates){
      var dates = dates.scheduledates
      this.templateSchedule = {
        Monday: [],
        Tuesday: [],
        Wednesday: [],
        Thursday: [],
        Friday: [],
        Saturday: [],
        Sunday: []
      }
      for (let index = 0; index < dates.length; index++) {
        delete dates[index].__typename
        delete dates[index].id
      }
      for (let i = 0; i < dates.length; i++) {
        const day = dates[i].day
        if (day == 'Monday') {
          this.templateSchedule.Monday.push(dates[i])
        }
        if (day == 'Tuesday') {
          this.templateSchedule.Tuesday.push(dates[i])
        }
        if (day == 'Wednesday') {
          this.templateSchedule.Wednesday.push(dates[i])
        }
        if (day == 'Thursday') {
          this.templateSchedule.Thursday.push(dates[i])
        }
        if (day == 'Friday') {
          this.templateSchedule.Friday.push(dates[i])
        }
        if (day == 'Saturday') {
          this.templateSchedule.Saturday.push(dates[i])
        }
        if (day == 'Sunday') {
          this.templateSchedule.Sunday.push(dates[i])
        }
      }
      this.currrent_schedule.dates = this.templateSchedule
      }
    },
    getTime (day, index, start_time, end_time) {
      const space = '  '
      if (start_time.toString() != '' && end_time.toString() != '') {
        if (end_time > start_time) {
          return ''
        } else {
          return `End Time is Less than Start Time at ${  day   }${space  }${index + 1}`
        }
      }
    },
    inputAdd (dayindex) {
      this.currrent_schedule.dates[dayindex].push({
        'start_time': '',
        'end_time': ''
      })
    },
    inputRemove (index, dayindex) {
      this.currrent_schedule.dates[index].splice(dayindex, 1)
    },
    initValues () {
      this.previewSchedule = '',
      this.ExBox = true
      this.templateSchedule = ''
      this.dataSchedule = ''
      // this.ViewBox=true
      this.currrent_schedule =
        {
          'id': '',
          'name': '',
          'dates': {
            Monday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ],
            Tuesday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ],
            Wednesday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ],
            Thursday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ],
            Friday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ],
            Saturday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ],
            Sunday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ]
          }
        }
    },
    oldRemove () {
      this.oldSchedule = ''
      this.$apollo
        .mutate({
          mutation: UPDATE_STUDENT,
          variables: {
            id :this.dataId,
            name:this.dataName,
            schedule_id:this.oldSchedule
          }
        })
        .then(response => {
          if (response) {
            this.StatusSuccess('Deleted')
            this.initValues()
          }
        })
        .catch(error => {
          this.StatusFail()
        })
      this.$emit('closeSidebar')
      this.dataSchedule = ''
      this.ExBox = true
      // this.ViewBox=true
      this.initValues()
    },
    StatusSuccess (status) {
      this.$emit('getdata', true)
      this.$vs.notify({
        title: 'Schedule',
        text: `Schedule ${status} Successfully!`,
        color: 'success',
        position: 'top-right'
      })
    },
    StatusFail () {
      this.$vs.notify({
        title: 'Schedule',
        text: 'Schedule assignment failed. Schedule must fall into cameras or location timings.',
        color: 'danger',
        position: 'top-right'
      })
    },
    RequiredMessage (item, action) {
      this.$vs.notify({
        title:this.$t('student.alert_title'),
        text: `${item  }`,
        color: 'danger',
        position: 'top-right'
      })
    },
    CheckCondtion1 (scheduleDates) {
      ////Condition1: Check if child days exist in parent
      //days of parent
      const parentScheduleDays = []

      for (const i in this.dataStudentSchedule.schedule.scheduledates) {
        const element  = this.dataStudentSchedule.schedule.scheduledates[i]

        if (element['start_time'] != '' && element['end_time'] != '') {

          if (parentScheduleDays.indexOf(element['day']) == -1) {
            parentScheduleDays.push(element['day'])
          }
        }
      }

      //days of child
      const childScheduleDays = []

      for (const i in scheduleDates) {
        const element  = scheduleDates[i]

        for (const j in element) {
          // console.log( "element" );
          // console.log( element[j] );

          if (element[j]['start_time'] != '' && element[j]['end_time'] != '') {

            if (childScheduleDays.indexOf(i) == -1) {
              childScheduleDays.push(i)
            }
          }

        }

      }

      // console.log(parentScheduleDays)
      // console.log(childScheduleDays)

      const condition1 = childScheduleDays.filter(d => !parentScheduleDays.includes(d)).length == 0

      const ddd = childScheduleDays.filter(d => !parentScheduleDays.includes(d))
      this.ddd = ddd
      // console.log( 'ddd' )
      // console.log( ddd )


      ////End Condition 1
    },

    MergeStudentScheduleSlots (StudentData) {

      // console.log("StudentData=")
      // console.log(StudentData)

      //Change location format into nested format

      //let StudentData = this.dataLocation.scheduledates

      //Nested format will be assigned to this variable
      const currentFormatSchedule = []

      for (const i  in StudentData.schedule.scheduledates) {
        const day = StudentData.schedule.scheduledates[i].day

        if (typeof (currentFormatSchedule[day]) === 'undefined') {
          currentFormatSchedule[day] = []
        }

        currentFormatSchedule[day].push({
          start_time : StudentData.schedule.scheduledates[i].start_time,
          end_time: StudentData.schedule.scheduledates[i].end_time
        })
      }

      // console.log("currentFormatSchedule=")
      // console.log( currentFormatSchedule )

      // console.log("currentFormatScheduleEND=")

      ////Merge Current Format Slots
      const current_schedule_dates = []

      for (const day in currentFormatSchedule) {
        let current_schedule_seconds_slots = []
        current_schedule_dates[day] = []

        for (const j in currentFormatSchedule[day]) {

          if (currentFormatSchedule[day][j].start_time != '' && currentFormatSchedule[day][j].end_time != '') {
            const  currentSlotStartTimeArray =  currentFormatSchedule[day][j].start_time.split(':')
            const  currentSlotEndTimeArray =  currentFormatSchedule[day][j].end_time.split(':')

            const  currentSlotStartTimeSeconds = parseInt(currentSlotStartTimeArray[0] * 60 * 60 + currentSlotStartTimeArray[1] * 60) //current start time seconds
            const  currentSlotEndTimeSeconds = parseInt(currentSlotEndTimeArray[0] * 60 * 60 + currentSlotEndTimeArray[1] * 60) //current end time seconds

            for (let s = currentSlotStartTimeSeconds; s <= currentSlotEndTimeSeconds; s += 60) {
              current_schedule_seconds_slots.push(s)
            }

          }
        }

        if (current_schedule_seconds_slots.length > 0) {
          current_schedule_seconds_slots = [...new Set(current_schedule_seconds_slots)].sort(function (a, b) { return a - b })

          // console.log(day)
          // console.log(current_schedule_seconds_slots)

          let startTime = current_schedule_seconds_slots[0]
          const endTime = ''

          for (const k in current_schedule_seconds_slots) {
            // console.log( current_schedule_seconds_slots[k] )
            // console.log( typeof( current_schedule_seconds_slots[k+1] ) )

            if (typeof (current_schedule_seconds_slots[parseInt(k) + 1]) === 'undefined' || current_schedule_seconds_slots[parseInt(k) + 1] - current_schedule_seconds_slots[k] != 60) {
              if (startTime != current_schedule_seconds_slots[k]) {
                current_schedule_dates[day].push({
                  start_time: startTime,
                  end_time: current_schedule_seconds_slots[k]
                })

                if (typeof (current_schedule_seconds_slots[parseInt(k) + 1]) !== 'undefined') {
                  startTime = current_schedule_seconds_slots[parseInt(k) + 1]
                }

              }

            }
          }

          //current_schedule_seconds_slots

          //console.log( current_schedule_seconds_slots )
        }
      }


      // console.log( 'current_schedule_dates' )
      // console.log( current_schedule_dates )

      // return

      ////End Merging Current Slots

      return current_schedule_dates
    },

    MergeCurrentSlot (scheduleDates) {
      ////Merge Current Slots

      const current_schedule_dates = []
      for (const day in scheduleDates) {
        let current_schedule_seconds_slots = []
        current_schedule_dates[day] = []

        for (const j in scheduleDates[day]) {
          if (scheduleDates[day][j].start_time != '' && scheduleDates[day][j].end_time != '') {
            const  currentSlotStartTimeArray =  scheduleDates[day][j].start_time.split(':')
            const  currentSlotEndTimeArray =  scheduleDates[day][j].end_time.split(':')

            const  currentSlotStartTimeSeconds = parseInt(currentSlotStartTimeArray[0] * 60 * 60 + currentSlotStartTimeArray[1] * 60) //current start time seconds
            const  currentSlotEndTimeSeconds = parseInt(currentSlotEndTimeArray[0] * 60 * 60 + currentSlotEndTimeArray[1] * 60) //current end time seconds

            for (let s = currentSlotStartTimeSeconds; s <= currentSlotEndTimeSeconds; s += 60) {
              current_schedule_seconds_slots.push(s)
            }

          }
        }
        if (current_schedule_seconds_slots.length > 0) {
          current_schedule_seconds_slots = [...new Set(current_schedule_seconds_slots)].sort(function (a, b) { return a - b })

          // console.log(day)
          // console.log(current_schedule_seconds_slots)

          let startTime = current_schedule_seconds_slots[0]
          const endTime = ''

          for (const k in current_schedule_seconds_slots) {
            // console.log( current_schedule_seconds_slots[k] )
            // console.log( typeof( current_schedule_seconds_slots[k+1] ) )

            if (typeof (current_schedule_seconds_slots[parseInt(k) + 1]) === 'undefined' || current_schedule_seconds_slots[parseInt(k) + 1] - current_schedule_seconds_slots[k] != 60) {
              if (startTime != current_schedule_seconds_slots[k]) {
                current_schedule_dates[day].push({
                  start_time: startTime,
                  end_time: current_schedule_seconds_slots[k]
                })

                if (typeof (current_schedule_seconds_slots[parseInt(k) + 1]) !== 'undefined') {
                  startTime = current_schedule_seconds_slots[parseInt(k) + 1]
                }

              }

            }
          }
          //current_schedule_seconds_slots

          //console.log( current_schedule_seconds_slots )
        }
      }


      // console.log( 'current_schedule_dates' )
      // console.log( current_schedule_dates )

      // return

      ////End Merging Current Slots

      this.current_schedule_dates = current_schedule_dates
    },
    submitData () {
      const finalschedule = []
      let scheduledates = ''
      if (this.ExBox) {
        scheduledates = this.currrent_schedule.dates
      } else {
        scheduledates = this.currrent_schedule.dates
      }
      for (let i = 0; i < scheduledates.Monday.length; i++) {
        var element = scheduledates.Monday[i]
        if (element['start_time'] != '' && element['end_time'] != '') {
          element['day'] = 'Monday'
          finalschedule.push(element)
        }
      }
      for (let i = 0; i < scheduledates.Tuesday.length; i++) {
        var element = scheduledates.Tuesday[i]
        if (element['start_time'] != '' && element['end_time'] != '') {
          element['day'] = 'Tuesday'
          finalschedule.push(element)
        }
      }
      for (let i = 0; i < scheduledates.Wednesday.length; i++) {
        var element = scheduledates.Wednesday[i]
        if (element['start_time'] != '' && element['end_time'] != '') {
          element['day'] = 'Wednesday'
          finalschedule.push(element)
        }
      }
      for (let i = 0; i < scheduledates.Thursday.length; i++) {
        var element = scheduledates.Thursday[i]
        if (element['start_time'] != '' && element['end_time'] != '') {
          element['day'] = 'Thursday'
          finalschedule.push(element)
        }
      }
      for (let i = 0; i < scheduledates.Friday.length; i++) {
        var element = scheduledates.Friday[i]
        if (element['start_time'] != '' && element['end_time'] != '') {
          element['day'] = 'Friday'
          finalschedule.push(element)
        }
      }
      for (let i = 0; i < scheduledates.Saturday.length; i++) {
        var element = scheduledates.Saturday[i]
        if (element['start_time'] != '' && element['end_time'] != '') {
          element['day'] = 'Saturday'
          finalschedule.push(element)
        }
      }
      for (let i = 0; i < scheduledates.Sunday.length; i++) {
        var element = scheduledates.Sunday[i]
        if (element['start_time'] != '' && element['end_time'] != '') {
          element['day'] = 'Sunday'
          finalschedule.push(element)
        }
      }
      this.previewSchedule = finalschedule
      let error = 0
      checkSchedule(finalschedule)
      function checkSchedule (finalschedule) {
        if (finalschedule.length > 0) {
          for (let i = 0; i < finalschedule.length; i++) {
            if (finalschedule[i].end_time <= finalschedule[i].start_time) {
              error++
            }
          }
        } else {
          error++
        }
      }
      if (this.ExBox) {
      // for (let i = 0; i <this.dataSchedule.scheduledates.length; i++) {
      //   if(this.dataSchedule.scheduledates[i].day=="Monday"){
      //      this.ex_current_schedule.dates.Monday.push(this.dataSchedule.scheduledates[i])
      //   }
      //   if(this.dataSchedule.scheduledates[i].day=="Tuesday"){
      //      this.ex_current_schedule.dates.Tuesday.push(this.dataSchedule.scheduledates[i])
      //   }
      //   if(this.dataSchedule.scheduledates[i].day=="Wednesday"){
      //      this.ex_current_schedule.dates.Wednesday.push(this.dataSchedule.scheduledates[i])
      //   }
      //   if(this.dataSchedule.scheduledates[i].day=="Thursday"){
      //      this.ex_current_schedule.dates.Thursday.push(this.dataSchedule.scheduledates[i])
      //   }
      //   if(this.dataSchedule.scheduledates[i].day=="Friday"){
      //      this.ex_current_schedule.dates.Friday.push(this.dataSchedule.scheduledates[i])
      //   }
      //   if(this.dataSchedule.scheduledates[i].day=="Saturday"){
      //      this.ex_current_schedule.dates.Saturday.push(this.dataSchedule.scheduledates[i])
      //   }
      //   if(this.dataSchedule.scheduledates[i].day=="Sunday"){
      //      this.ex_current_schedule.dates.Sunday.push(this.dataSchedule.scheduledates[i])
      //   }
      // }
        // this.CheckCondtion1(this.currrent_schedule.dates)
        // this.MergeCurrentSlot(this.currrent_schedule.dates)
        // const studentMergedSlots = this.MergeStudentScheduleSlots(this.dataStudentSchedule)
        // console.log(studentMergedSlots)
        ////Condition 2: check each slot
        // let condition2 = true
        // let totalCurrentSlotSlots = 0
        // let validCurrentSlots = 0

        // for (const day in this.current_schedule_dates) {
        //   for (const j in this.current_schedule_dates[day]) {
        //     // console.log(this.current_schedule_dates[day][j])

        //     if (this.current_schedule_dates[day][j].start_time.toString() != '' && this.current_schedule_dates[day][j].end_time != '') {
        //       totalCurrentSlotSlots++

        //       const  currentSlotStartTimeSeconds =  this.current_schedule_dates[day][j].start_time
        //       const  currentSlotEndTimeSeconds =  this.current_schedule_dates[day][j].end_time

        //       for (const i in studentMergedSlots[day]) {

        //         if (currentSlotStartTimeSeconds >= studentMergedSlots[day][i].start_time && currentSlotEndTimeSeconds <= studentMergedSlots[day][i].end_time) {
        //           validCurrentSlots++
        //           break
        //         }
        //       }

        //     }
        //   }
        // }
        // console.log( totalCurrentSlotSlots );
        // console.log( validCurrentSlots );
        // condition2 = totalCurrentSlotSlots == validCurrentSlots
        //// End Condition 2
        // if (totalCurrentSlotSlots == validCurrentSlots && this.ddd.length == 0 && totalCurrentSlotSlots + validCurrentSlots !== 0) {
        this.$validator.validateAll().then(result => {
          if (result && error == 0) {
            if (finalschedule.length > 0) {
              this.$apollo
                .mutate({
                  mutation: CREATE_STUDENT_SCHEDULE,
                  variables: {
                    id :this.dataId,
                    schedule_name:`${'Student' + ' '}${this.dataId} ` + 'Schedule',
                    scheduledates: finalschedule
                  }
                })
                .then(response => {
                  if (response.data.createStudentSchedule.status == 'SUCCESS') {
                    this.StatusSuccess('Created')
                    this.userActivity(this.dataId)
                    this.$emit('closeSidebar')
                    this.initValues()
                  }
                }).catch(error => {
                  console.log(error)
                })
            }
          } else {
            this.RequiredMessage('Schedule is Required', 'Failed')
          }
        })
        // } else {
        //   this.StatusFail()
        // }
      }
    },
    newcheck (val) {
      this.ExBox = !val
    },
    //  excheck(val){
    //   if(val){
    //   this.NewBox=!val
    //   this.ViewBox=!val
    //   }
    //   else{
    //     this.ViewBox=true
    //   }
    // },
    // newcheck(val){
    //   if(val){
    //   this.ExBox=!val
    //   this.ViewBox=!val
    //   }
    //   else{
    //     this.ViewBox=true
    //   }
    // },
    userActivity (id) {
      // alert(id)
      this.$apollo
        .mutate({
          mutation: CREATE_USER_ACTIVITY,
          variables: {
            object_id: id,
            object_type:'App\\Models\\Student',
            activity:'updated'
          }
        }).then(response => {
          if (response) {
            // this.updateUserActivity()
          }
        })
    },
    // updateUserActivity () {
    //   this.$apollo
    //     .mutate({
    //       mutation: UPDATE_USER_ACTIVITY,
    //       variables: {
    //         object_id: this.dataId,
    //         object_type:'App\\Models\\Student',
    //         activity:'updated'
    //       }
    //     })
    // }
  },

  created () {
    this.$apollo
      .mutate({
        mutation: ALL_SCHEDULE,
        variables: {
          status:1
        }
      })

      .then(response => {
        this.schedules = response.data.schedules
      })
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }

}
</style>
<style>
.timepicker{
  width: 100%;
}
.vs-tooltip{
  z-index: 99999 ;
}
</style>
